import { ConsentFormTemplate } from '@lmc/common/types'
import { ConsentForm, Resident } from '@lmc/ts-common'

export const getResidentShortCut = (resident: Resident) =>
  `${resident?.name?.first.toUpperCase().charAt(0)}${resident?.name?.last
    .toUpperCase()
    .charAt(0)}`

export const isMatchingFormBody = (
  item: any,
  templates: ConsentFormTemplate[]
) => {
  // @ts-ignore
  if (templates.find((form) => form.id === item.id).body.match(item.body)) {
    return true
  }
  return false
}

export const getResidentConsentFormsTemplates = (
  templates: any,
  consentForms: any
) =>
  templates?.filter(
    (template: any) =>
      !consentForms
        ?.filter((form: any) => !form.isArchived)
        .map((form: any) => form.consentTemplate)
        .includes(template.id)
  )

export const customConsentFormsEmpty = (
  consentForms: ConsentForm[],
  sideControlIds: any[]
) =>
  (!sideControlIds?.length ||
    sideControlIds?.every((item) => item.isSelected === false)) &&
  consentForms.every(
    (consentForm) =>
      consentForm.isCustom &&
      consentForm.body === `<p>Custom Form</p>` &&
      consentForm.title === `Custom Title`
  )
